import { useContext, useEffect, useRef } from 'react';
import { DialogContext } from '../../context/DialogContext';
import { TestingHqContext } from '../../context/TestingHqContext';

import List from '../../components/list/List';
import { get_testing_schedule_list } from '../../utils/restapi';
import './list.css';
import TestingPaperJoin from './paper_join';
import TestingReportJoin from './report_join';
import TestingCostJoin from './cost_join';

const TestingReportList = () => {
  const { testingHqs } = useContext(TestingHqContext);

  const { openDialog, closeDialog } = useContext(DialogContext);
  const listRef = useRef(null);

  // List에서 사용할 데이터 가져오기 함수
  const handleGetData = async (params) => {
    if (testingHqs.length === 0) {
      return {
        total: 0,
        totalPages: 0,
        page: params.page || 1,
        rowsPerPage: params.rowsPerPage || 20,
        keyword: params.keyword || '',
        sort: params.sort || '',
        desc: params.desc || '',
        lists: []
      }; // 고사본부가 없으면 빈 배열 반환
    }

    const requestParams = {
      type:1, // 시험유형 고정
      hcodes: testingHqs.map(hq => hq.code).join(','),
      ...params
    };

    console.log("handleGetData requestParams:", requestParams);
    return await get_testing_schedule_list(requestParams);
  };

  //시험지 수령 보고 버튼 클릭 핸들러
  const handleTestingPaperJoin = (item) => {
    console.log('시험지 수령 보고:', item);
    // 보고 처리 로직 추가
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      },
    };

    const handleClose = () => {
      closeDialog();
    };

    openDialog(
      <TestingPaperJoin
        testingScheduleObj={item}
        onClose={handleClose}
      />, 
      customStyles
    );
  };

  //시험결과 보고 버튼 클릭 핸들러
  const handleTestingReportJoin = (item) => {
    console.log('시험결과 보고:', item);
    // 보고 처리 로직 추가
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      },
    };

    const handleClose = () => {
      closeDialog();
    };

    openDialog(
      <TestingReportJoin
        testingScheduleObj={item}
        onClose={handleClose}
      />, 
      customStyles
    );
  };
  
  //비용 청구 버튼 클릭 핸들러
  const handleTestingCostJoin = (item) => {
    console.log('비용 청구:', item);
    // 청구 처리 로직 추가
    // 보고 처리 로직 추가
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      },
    };

    const handleClose = () => {
      closeDialog();
    };

    openDialog(
      <TestingCostJoin
        testingScheduleObj={item}
        onClose={handleClose}
      />, 
      customStyles
    );
  };

  // headers에 renderCell 함수를 포함시킴
  const headers = [
    {
      name: 'NO.',
      value: 'a_testing_schedule_id',
      renderCell: (item) => item.testing_schedule_id
    },
    {
      name: '시험구분',
      value: 'b_type',
      renderCell: (item) => item.testingObj.typeName
    },
    {
      name: '시험회차',
      value: 'b_title',
      renderCell: (item) => item.testingObj.title
    },
    {
      name: '시험일자',
      value: 'a_testStartDate',
      renderCell: (item) => item.testStartDate
    },
    {
      name: '결과발표',
      value: 'a_resultDate',
      renderCell: (item) => item.resultDate
    },
    {
      name: '비고',
      value: '',
      renderCell: (item) => {
        const now = new Date();
        const confirmStartDate = item.confirmStartDate ? new Date(item.confirmStartDate) : null;
        if (confirmStartDate && confirmStartDate <= now) {
          return (
            <>
              <button onClick={(e) => handleTestingPaperJoin(item)}>시험지 수령 보고</button>
              <button onClick={(e) => handleTestingReportJoin(item)}>시험결과 보고</button>
              <button onClick={(e) => handleTestingCostJoin(item)}>비용 청구</button>
            </>
          );
        }
        return null;
      }
    },
  ];

  useEffect(() => {
    listRef.current?.refresh();
  }, [testingHqs.length]);

  return (
    <div id="testing_report_list">
      <div className="head">
        <h1>회차별 결과보고</h1>
      </div>
      <div className="body">
        <div className="middle">
          <List
            ref={listRef}
            headers={headers}
            onGetData={handleGetData}
            className="testing_report_table"
            initialSort="a_testing_schedule_id"
            initialDesc="desc"
            initialRowsPerPage={20}
          />
        </div>
        <div className="bottom">
        </div>
      </div>
    </div>
  );
};

export default TestingReportList;
